import formsPlugin from '@tailwindcss/forms';
import { BACKGROUND_COLORS, baseColors, navBackground, textColor } from './colors.js';
import { CATEGORY_1_SHIFT_DARK_COLORS, CATEGORY_1_SHIFT_LIGHT_COLORS, CATEGORY_1_UNIQUE_COLORS, CATEGORY_1_UNIQUE_DARK_COLORS, CATEGORY_1_UNIQUE_LIGHT_COLORS, CATEGORY_2_SHIFT_DARK_COLORS, CATEGORY_2_SHIFT_LIGHT_COLORS, CATEGORY_2_UNIQUE_COLORS, CATEGORY_2_UNIQUE_DARK_COLORS, CATEGORY_2_UNIQUE_LIGHT_COLORS } from './category_palette.js';
export const config = {
    prefix: 'tw-',
    content: [],
    darkMode: 'class',
    theme: {
        colors: {
            nav: navBackground,
            ...baseColors,
            'category-1-shift-light': CATEGORY_1_SHIFT_LIGHT_COLORS,
            'category-1-shift-dark': CATEGORY_1_SHIFT_DARK_COLORS,
            'category-1-unique': CATEGORY_1_UNIQUE_COLORS,
            'category-1-unique-light': CATEGORY_1_UNIQUE_LIGHT_COLORS,
            'category-1-unique-dark': CATEGORY_1_UNIQUE_DARK_COLORS,
            'category-2-shift-light': CATEGORY_2_SHIFT_LIGHT_COLORS,
            'category-2-shift-dark': CATEGORY_2_SHIFT_DARK_COLORS,
            'category-2-unique': CATEGORY_2_UNIQUE_COLORS,
            'category-2-unique-light': CATEGORY_2_UNIQUE_LIGHT_COLORS,
            'category-2-unique-dark': CATEGORY_2_UNIQUE_DARK_COLORS
        },
        textColor,
        screens: {
            xs: '640px',
            // => @media (min-width: 640px) { ... }
            sm: '768px',
            // => @media (min-width: 768px) { ... }
            md: '1024px',
            // => @media (min-width: 1024px) { ... }
            lg: '1366px',
            // => @media (min-width: 1366px) { ... }
            xl: '1920px'
            // => @media (min-width: 1920px) { ... }
        },
        fontSize: {
            '2xs': ['0.6875rem', { letterSpacing: '0.2px', lineHeight: '1rem' }],
            xs: ['0.75rem', { letterSpacing: '0px', lineHeight: '1rem' }],
            sm: ['0.875rem', { letterSpacing: '0px', lineHeight: '1.25rem' }],
            base: ['1rem', { letterSpacing: '0px', lineHeight: '1.5rem' }],
            lg: ['1.25rem', { letterSpacing: '0px', lineHeight: '1.75rem' }],
            xl: ['1.5rem', { letterSpacing: '0px', lineHeight: '2rem' }],
            '2xl': ['1.75rem', { letterSpacing: '0px', lineHeight: '2.25rem' }],
            '3xl': ['2rem', { letterSpacing: '-0.2px', lineHeight: '2.5rem' }],
            '4xl': ['2.5rem', { letterSpacing: '-0.2px', lineHeight: '3rem' }],
            '5xl': ['3rem', { letterSpacing: '-0.2px', lineHeight: '3.5rem' }]
        },
        extend: {
            animation: {
                flicker: 'flicker 2s infinite',
                shake: 'shake 0.82s cubic-bezier(.36,.07,.19,.97) both',
                fadeIn: 'fadeIn 0.2s',
                reveal: 'fadeIn 0.5s'
            },
            backgroundColor: BACKGROUND_COLORS,
            lineHeight: {
                '4.5': '1.125rem'
            },
            borderRadius: {
                xs: '0.063rem'
            },
            boxShadow: {
                right: '-2px 0px 3px 0px rgba(0,0,0,0.1)',
                left: '2px 0px 3px 0px rgba(0,0,0,0.1)',
                'dark-left': '2px 0px 3px 0px rgba(0,0,0,0.35)',
                'dark-right': '-2px 0px 3px 0px rgba(0,0,0,0.35)',
                'dark-modal': '0px 4px 16px 8px rgba(0,0,0,0.96)',
                popover: '0 4px 12px 0 rgba(0,0,0,0.16)',
                'dark-popover': '0 4px 12px 0 rgba(0,0,0,0.88)',
                'dark-sheet': '0 4px 16px 8px rgba(0,0,0,0.88)',
                card: '0 2px 8px 0 rgba(0, 0, 0, 0.16)',
                'card-dark': '0 2px 8px 0 rgba(0, 0, 0, 0.88)',
                toast: '0 4px 24px 0 rgba(0, 0, 0, 0.16)',
                'toast-dark': '0 4px 24px 0 rgba(0, 0, 0, 0.88)'
            },
            fontFamily: {
                lato: ['lato', 'sans-serif']
            },
            keyframes: {
                fadeIn: {
                    '0%': { opacity: '0' },
                    '100%': { opacity: '1' }
                },
                flicker: {
                    '0%': { opacity: '1' },
                    '100%': { opacity: '1' },
                    '50%': { opacity: '0.25' }
                },
                shake: {
                    '10%, 90%': { transform: 'translate3d(-1px, 0, 0)' },
                    '20%, 80%': { transform: 'translate3d(2px, 0, 0)' },
                    '30%, 50%, 70%': { transform: 'translate3d(-4px, 0, 0)' },
                    '40%, 60%': { transform: 'translate3d(4px, 0, 0)' }
                }
            },
            opacity: {
                '6': '.06',
                '16': '.16'
            },
            spacing: {
                '17': '4.2rem',
                '18': '4.5rem',
                '22': '5.5rem',
                '30': '7.5rem',
                '34': '8.5rem',
                '38': '9.5rem',
                '54': '13.5rem',
                '70': '17.625rem'
            },
            transitionProperty: {
                width: 'width',
                colors: 'colors'
            }
        }
    },
    plugins: [
        formsPlugin({
            strategy: 'class'
        }),
        ({ addUtilities }) => {
            addUtilities({
                '.icon-primary': { '@apply tw-text-white': {} },
                '.icon-primary-dark': { '@apply tw-text-blue-100': {} },
                '.icon-secondary': { '@apply tw-text-blue-600': {} },
                '.icon-secondary-dark': { '@apply tw-text-blue-400': {} },
                '.icon-tertiary': { '@apply tw-text-gray-700': {} },
                '.icon-tertiary-dark': { '@apply tw-text-gray-400': {} },
                '.icon-disabled': { '@apply tw-text-gray-400': {} },
                '.icon-disabled-dark': { '@apply tw-text-gray-600': {} },
                '.icon-error': { '@apply tw-text-red-500': {} },
                '.icon-success': { '@apply tw-text-teal-500': {} },
                '.icon-success-dark': { '@apply tw-text-teal-400': {} }
            });
        }
    ]
};
//# sourceMappingURL=config.js.map